import { ValidatorFn, Validators } from '@angular/forms';

export class PhoneValidation {
  static validations: ValidatorFn[] = [
    Validators.minLength(10),
    Validators.maxLength(10),
    Validators.pattern('[0-9]*'),
  ];
}
